"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = require("./base");
exports.default = new base_1.FlowNodeSpec({
    name: 'Create Data Link',
    description: 'Link records between your app and external app',
});
//# sourceMappingURL=create-data-link.js.map